"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  value: number;
  suffix: string;
  label: string;
};
const stats: Stat[] = [{
  value: 5,
  suffix: "",
  label: "Active Chapters"
}, {
  value: 850,
  suffix: "+",
  label: "Code Commits"
}, {
  value: 120,
  suffix: "+",
  label: "Weekly Workshops"
}, {
  value: 100,
  suffix: "%",
  label: "Open Source"
}];
function AnimatedNumber({
  value,
  suffix,
  isVisible,
  index
}: {
  value: number;
  suffix: string;
  isVisible: boolean;
  index: number;
}) {
  const [display, setDisplay] = useState(0);
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!isVisible) return;
    const duration = 1500;
    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - start;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(value * eased);
      if (t < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setDone(true);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [isVisible, value]);
  const formatted = value < 10 && value % 1 !== 0 ? display.toFixed(1) : Math.floor(display).toLocaleString();
  return <span data-index={index} className={`font-default tabular-nums tracking-tight transition-[text-shadow] duration-700 ${done ? "[text-shadow:0_0_24px_rgba(192,38,211,0.3)]" : ""}`} style={{
    fontWeight: 700
  }}>
      <span className="text-foreground">{formatted}</span>
      <span className="text-purple-500" style={{
      fontSize: "0.5em",
      verticalAlign: "top",
      marginLeft: "0.05em"
    }}>
        {suffix}
      </span>
    </span>;
}
export default function HubImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.25
  });
  return <section data-section-id="901" id="hub-impact" className="bg-background text-foreground relative overflow-hidden py-32 md:py-40 px-6 md:px-10">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      backgroundImage: "linear-gradient(to right, hsl(240 5% 15% / 0.4) 1px, transparent 1px), linear-gradient(to bottom, hsl(240 5% 15% / 0.4) 1px, transparent 1px)",
      backgroundSize: "64px 64px"
    }} />

      <div ref={ref} className="relative mx-auto max-w-7xl">
        {}
        <div className="text-center mb-6">
          <span className="text-xs uppercase tracking-[0.2em] text-purple-500 font-mono" style={{
          letterSpacing: "0.2em"
        }}>COMMUNITY IMPACT</span>
        </div>

        {}
        <h2 className="font-default text-center text-3xl md:text-5xl font-semibold tracking-tight text-foreground mb-20 md:mb-24 max-w-3xl mx-auto">
          Building the future, one commit at a time.
        </h2>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-16 md:gap-y-0 relative">
          {stats.map((stat, i) => <div data-index={i} key={i} className={`relative flex flex-col items-center text-center px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: `${i * 120}ms`
        }}>
              {}
              {i > 0 && <div aria-hidden="true" className={`absolute left-0 top-1/2 -translate-y-1/2 h-24 md:h-32 w-px bg-border/50 ${i % 2 === 0 ? "hidden md:block" : ""}`} />}

              {}
              <div className="text-6xl sm:text-7xl md:text-8xl leading-none mb-6">
                <AnimatedNumber value={stat.value} suffix={stat.suffix} isVisible={isVisible} index={i} />
              </div>

              {}
              <div className="h-px w-10 bg-purple-500 mb-5" />

              {}
              <div className="text-xs uppercase text-foreground/70 font-medium" style={{
            letterSpacing: "0.15em"
          }}>
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}